import React from "react";

import "bootstrap/dist/css/bootstrap.min.css"

import "../App.css"
import "./style.css"
const CssLoader =()=>(<></>)

export default CssLoader